import { Color } from "@material-ui/core";
import createMuiTheme from "@material-ui/core/styles/createTheme";
import { MuiPickersOverrides } from "@material-ui/pickers/typings/overrides";

// Declare custom theme properties here
declare module "@material-ui/core/styles/createPalette" {
    // tslint:disable-next-line:interface-name
    interface Palette {
        success: PaletteColor;
    }

    // tslint:disable-next-line:interface-name
    interface PaletteOptions {
        success?: SimplePaletteColorOptions | Partial<Color>;
    }

    // tslint:disable-next-line:interface-name
    interface TypeBackground {
        overlay: React.CSSProperties["backgroundColor"];
        dark: React.CSSProperties["backgroundColor"];
    }
}
type overridesNameToClassKey = {
    [P in keyof MuiPickersOverrides]: keyof MuiPickersOverrides[P];
};

declare module "@material-ui/core/styles/overrides" {
    interface ComponentNameToClassKey extends overridesNameToClassKey {}
}

declare module "@material-ui/core/styles/createTheme" {
    // tslint:disable-next-line:interface-name
    interface Theme {
        bodyContent: {
            maxWidth: React.CSSProperties["maxWidth"];
            desktopPadding: React.CSSProperties["padding"];
            mobilePadding: React.CSSProperties["padding"];
        };
        layout: { maxWidth: React.CSSProperties["maxWidth"] };
        navbar: { height: React.CSSProperties["height"] };
    }
    // tslint:disable-next-line:interface-name
    interface ThemeOptions {
        bodyContent?: {
            maxWidth?: React.CSSProperties["maxWidth"];
            desktopPadding?: React.CSSProperties["padding"];
            mobilePadding?: React.CSSProperties["padding"];
        };
        layout?: { maxWidth?: React.CSSProperties["maxWidth"] };
        navbar?: { height?: React.CSSProperties["height"] };
    }
}

export const maxBodyWidth = 1140;
export const navbarHeight = 80;
export const desktopPadding = 40;

export default function createGlobalTheme() {
    const backdropColor = "rgba(0, 0, 0, 0.75)";

    const theme = createMuiTheme();

    return createMuiTheme({
        bodyContent: {
            desktopPadding,
            maxWidth: maxBodyWidth,
            mobilePadding: 24
        },
        layout: { maxWidth: 1680 },
        navbar: { height: navbarHeight },
        overrides: {
            MuiBackdrop: { root: { backgroundColor: backdropColor } },
            MuiExpansionPanelSummary: {
                content: { alignItems: "center" },
                expandIcon: { transform: "translateY(-50%) !important" },
                root: {
                    [theme.breakpoints.down("sm")]: {
                        padding: "0 24px 0 24px"
                    },
                    padding: "0 32px 0 32px"
                }
            },
            // MuiModal: {
            //     root: {
            //         alignItems: "center",
            //         display: "flex",
            //         justifyContent: "center"
            //     }
            // },
            MuiMenuItem: {
                root: { color: "white" }
            },
            MuiInputBase: {
                root: { color: "white" },
                input: { color: "white" }
            },
            MuiTypography: {
                button: { letterSpacing: "0.0857em" },
                body1: { color: "white" }
            },
            MuiButton: {
                contained: {
                    color: "#231F20",
                    backgroundColor: "rgba(248, 179, 50, 1)"
                }
            },
            MuiFab: {
                extended: {
                    color: "#231F20",
                    backgroundColor: "rgba(248, 179, 50, 1)",
                    fontWeight: "bold",
                    borderRadius: "4px"
                }
            },
            MuiInputLabel: {
                root: {
                    color: "#CCCCCC"
                }
            },
            MuiFormHelperText: {
                root: {
                    color: "#CCCCCC"
                }
            },
            MuiFormLabel: {
                asterisk: {
                    color: "white"
                },
                root: {
                    color: "white"
                }
            },
            MuiDivider: {
                root: {
                    backgroundColor: "#424242"
                }
            },
            MuiTable: {
                root: {
                    backgroundColor: "#FFFFFF"
                }
            },
            MuiPickersToolbar: {
                toolbar: {
                    backgroundColor: "rgba(248, 179, 50, 1)"
                }
            },
            MuiPickerDTTabs: {
                tabs: {
                    backgroundColor: "rgba(248, 179, 50, 1)"
                }
            },
            MuiPickersCalendarHeader: {
                switchHeader: {
                    backgroundColor: "#fff"
                },
                daysHeader: {
                    backgroundColor: "#fff"
                }
            },
            MuiPickersSlideTransition: {
                transitionContainer: {
                    backgroundColor: "#fff"
                }
            },
            MuiPickersClock: {
                container: {
                    backgroundColor: "#fff"
                }
            },
            MuiTablePagination: {
                root: {
                    color: "#fff"
                },
                input: {
                    color: "#fff"
                }
            }
        },
        palette: {
            background: {
                default: "rgba(242, 241, 240, 1)",
                overlay: backdropColor,
                paper: "#231F20",
                dark: "rgba(222, 222, 222, 1)"
            },
            common: {
                black: "#000",
                white: "#fff"
            },
            divider: "rgba(210, 210, 210, 1)",
            error: {
                contrastText: "#fff",
                dark: "#d32f2f",
                light: "#e57373",
                main: "#f44336"
            },
            primary: {
                contrastText: "#fff",
                dark: "rgba(247, 165, 12, 1)",
                light: "rgba(251, 207, 126, 1)",
                main: "rgba(248, 179, 50, 1)"
            },
            secondary: {
                contrastText: "#fff",
                dark: "rgba(22, 22, 22, 1)",
                light: "rgba(129, 129, 129, 1)",
                main: "rgba(51, 51, 51, 1)"
            },
            success: {
                contrastText: "#fff",
                dark: "rgba(95, 138, 55, 1)",
                light: "rgba(194, 220, 169, 1)",
                main: "rgba(124, 180, 72, 1)"
            },
            text: {
                disabled: "rgba(255, 255,255, 0.75)",
                hint: "rgba(0, 0, 0, 0.38)",
                primary: "rgba(51, 51, 51, 1)",
                secondary: "rgba(102, 102, 102, 1)"
            },
            type: "dark"
        }
    });
}
